// Hero title: split the <br>-separated title into one div per line, then scale
// each line so its inked width -- not its advance width -- fills the box.
// Needs jQuery + bigtext, both loaded from the CDN in Webflow.
import { onReady } from '../utils/ready.js';

export function initHeroTitle() {
var SEL = '.section-hero__title-text';
var timer = 0;
function splitLines(w) {
  var line = w.firstElementChild;
  if (!line || w.children.length !== 1) return;
  var parts = [],
    buf = '';
  [].forEach.call(line.childNodes, function (n) {
    if (n.nodeName === 'BR') {
      parts.push(buf);
      buf = '';
    } else {
      String(n.textContent).split('\n').forEach(function (seg, i) {
        if (i > 0) {
          parts.push(buf);
          buf = '';
        }
        buf += seg;
      });
    }
  });
  parts.push(buf);
  parts = parts.map(function (p) { return p.trim(); }).filter(Boolean);
  if (parts.length < 2) return;
  var cls = line.className;
  w.innerHTML = '';
  parts.forEach(function (p) {
    var d = document.createElement('div');
    d.className = cls;
    d.textContent = p;
    w.appendChild(d);
  });
}
function inkFit(w) {
  var W = w.clientWidth;
  if (!W) return;
  var ctx = document.createElement('canvas').getContext('2d');
  [].forEach.call(w.children, function (line) {
    var cs = getComputedStyle(line);
    var F = parseFloat(cs.fontSize);
    var text = line.textContent;
    if (cs.textTransform === 'uppercase') text = text.toUpperCase();
    else if (cs.textTransform === 'lowercase') text = text.toLowerCase();
    ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + F + 'px ' + cs.fontFamily;
    var ls = parseFloat(cs.letterSpacing) || 0;
    var native = 'letterSpacing' in ctx;
    if (native) ctx.letterSpacing = cs.letterSpacing;
    var m = ctx.measureText(text);
    var ink = m.actualBoundingBoxLeft + m.actualBoundingBoxRight + (native ? 0 : (text.length - 1) * ls);
    if (!(ink > 0) || !(F > 0)) return;
    var F2 = (F * W) / ink;
    line.style.fontSize = F2 + 'px';
    line.style.marginLeft = (m.actualBoundingBoxLeft * F2) / F + 'px';
    line.style.textAlign = 'left';
  });
}
function fitNode(w) {
  var $ = window.jQuery;
  if (!$ || !$.fn.bigtext) return false;
  [].forEach.call(w.children, function (line) {
    line.style.fontSize = '';
    line.style.marginLeft = '';
    line.style.textAlign = '';
  });
  $(w).bigtext({ maxfontsize: 3000, resize: false });
  inkFit(w);
  w.classList.add('is-fitted');
  return true;
}
function run() {
  var nodes = [].slice.call(document.querySelectorAll(SEL));
  if (!nodes.length) return true;
  return nodes.map(fitNode).every(Boolean);
}
window.fitHeroTitle = function (w) {
  splitLines(w);
  return fitNode(w);
};
function start() {
  var nodes = [].slice.call(document.querySelectorAll(SEL));
  if (!nodes.length) return;
  nodes.forEach(splitLines);
  var fonts = document.fonts;
  var first = function () {
    if (!run()) window.addEventListener('load', run);
  };
  if (fonts && fonts.ready && fonts.load) {
    var cs = getComputedStyle(nodes[0].firstElementChild || nodes[0]);
    var face = fonts.load(cs.fontWeight + ' 1em ' + cs.fontFamily).catch(function () {});
    Promise.all([face, fonts.ready]).then(first);
    setTimeout(function () {
      if (!nodes[0].classList.contains('is-fitted')) first();
    }, 2000);
  } else {
    first();
  }
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(run, 120);
  });
}

  onReady(start);
}
